import { useEffect } from 'react';

const DOMAIN = 'https://agencia-ppc.es';

const setMeta = (selector, attr, value) => {
  const el = document.querySelector(selector);
  if (!el) return null;
  const prev = el.getAttribute(attr);
  el.setAttribute(attr, value);
  return () => el.setAttribute(attr, prev);
};

// Per-page title, description, hreflang alternates and JSON-LD; restored on unmount.
export const usePageSeo = ({ title, description, alternates, jsonLd }) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;
    const restores = [
      setMeta('meta[name="description"]', 'content', description),
      setMeta('meta[property="og:title"]', 'content', title),
      setMeta('meta[property="og:description"]', 'content', description),
    ].filter(Boolean);

    const staticAlternates = [...document.querySelectorAll('link[rel="alternate"][hreflang]')];
    staticAlternates.forEach((n) => n.remove());
    const staticFaq = [...document.querySelectorAll('script[type="application/ld+json"]')].filter((n) => n.text.includes('"FAQPage"'));
    staticFaq.forEach((n) => n.remove());
    const added = [];
    Object.entries({ ...alternates, 'x-default': alternates.es }).forEach(([lang, path]) => {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = lang;
      link.href = `${DOMAIN}${path}`;
      link.dataset.pageSeo = '1';
      document.head.appendChild(link);
      added.push(link);
    });
    jsonLd.forEach((data) => {
      const s = document.createElement('script');
      s.type = 'application/ld+json';
      s.text = JSON.stringify(data);
      document.head.appendChild(s);
      added.push(s);
    });

    return () => {
      document.title = prevTitle;
      restores.forEach((r) => r());
      added.forEach((n) => n.remove());
      staticAlternates.forEach((n) => document.head.appendChild(n));
      staticFaq.forEach((n) => document.head.appendChild(n));
    };
  }, [title, description, alternates, jsonLd]);
};
